import { render, staticRenderFns } from "./DistributionOfPayrollExpenses.vue?vue&type=template&id=42ff361a"
import script from "./DistributionOfPayrollExpenses.vue?vue&type=script&lang=js"
export * from "./DistributionOfPayrollExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports